
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const Ghost = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="Ghost" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M8 1a4.951 4.951 0 00-5 4.90151Q2.99951 5.95075 3 6v7.6l.3-.3.7-.7.7.7L6 14.6l1.3-1.3.7-.7.7.7 1.3 1.3 1.3-1.3.7-.7.7.7.3.3V6a4.951 4.951 0 00-4.90151-5Q8.04924.9995 8 1m0-1a6.018 6.018 0 016 6v10l-2-2-2 2-2-2-2 2-2-2-2 2V6a6.018 6.018 0 016-6zm1 6h2v2H9zM5 6h2v2H5z" />
</svg>
    </HvIconBase>
)};

Ghost.propTypes = HvIconBase.propTypes;

export default Ghost;